import React from 'react';
import i18n, { formatNumber } from '@/utils/i18n';
import { Table } from 'reactstrap';
import { ContainerType } from '../OrderFulfillmentAddContainerTypes';
import ContainerTypeDisplay from '../../../../../components/ContainerType/ContainerTypeDisplay';
import { Routes } from '@/utils/routes';
import { Link } from 'react-router-dom';

type RemovedContainerStationManualAmountProps = {
  containerTypes: ContainerType[];

  removedManualAmount: {
    containerStationId: number;
    containerTypeId: number;
    amount: number;
    removed: boolean;
  };
};

const RemovedContainerStationManualAmount = ({
  containerTypes,
  removedManualAmount,
}: RemovedContainerStationManualAmountProps) => {
  const { containerStationId, containerTypeId, amount } = removedManualAmount;

  const containerType = containerTypes.find((ct) => {
    return ct.id === containerTypeId;
  });

  return (
    <Table style={{ width: '100%', tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>{i18n.t('OrderFulfillment:containerStation')}</th>
          <th>{i18n.t('OrderFulfillment:containerType')}</th>
          <th>{i18n.t('Common:amount')}</th>
          <th>{i18n.t('OrderFulfillment:change')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <Link to={Routes.containerStation(containerStationId.toString())}>
              {containerStationId}
            </Link>
          </td>
          <td>
            <ContainerTypeDisplay
              containerType={containerType}
              showContainerId={false}
              showStrikedThrough
              size="s"
            />
          </td>
          <td>
            <p>
              <s className="numbers-formatted">{formatNumber(amount)}</s>
            </p>
          </td>
          <td>
            <div className="text-danger">
              {i18n.t('OrderFulfillment:removedManualAmount')}
            </div>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default RemovedContainerStationManualAmount;
